<template>
	<div>
		<v-select
		v-model="plan"
		:items="subscription_plans"
		item-text="name"
		item-value="id"
		:placeholder="$lang.PLAN"
		@focus="subscriptionPlanAutoComplete"
		@change="updateWholesaler"
		append-icon="mdi-menu-down"
		single-line
		outlined
		clearable
		dense
		return-object
		:rules="$rules.PLAN"
		:loading="loading"
		>
		<template v-slot:item="data">
			<v-list-item-content>
				<v-list-item-title >{{data.item.name}} <span v-if="data.item.plan_type==$keys.ADDON_PLAN||data.item.plan_type==$keys.SPECIAL_PLAN" class="addon_plan">{{data.item.plan_type}}</span></v-list-item-title>
				<v-list-item-subtitle v-html="data.item.price"></v-list-item-subtitle>
			</v-list-item-content>
		</template>
	</v-select> 		
</div>
</template>
<script type="text/javascript">

export default {
	data () {
		return {
			loading:false,	
			subscription_plans:[],
			plan:null,
		}
	},
	methods:{
		updateWholesaler(){
			this.$emit("update-plan", this.plan);
		},
		subscriptionPlanAutoComplete(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};

			const successHandler = (response) => {
				if (response.data.success){
					self.subscription_plans=response.data.subscription_list
				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.SUBSCRIPTON_LIST,params,successHandler,null,null,finallyHandler,true)


		}
	}
}
</script>